import { Component } from 'react';
import classNames from 'classnames';
import DragCell from './DragCell';
import * as uiHelper from '../../../util/ui';
require('./DragGrid.scss');

class DragGrid extends Component {
    constructor(props) {
        super(props);
        this.handleTouchAdd = this.handleTouchAdd.bind(this);
        this.getContainer = this.getContainer.bind(this);
        this.moveToCell = this.moveToCell.bind(this);
        this.closeTip = this.closeTip.bind(this);
        this.overCellStyle = this.overCellStyle.bind(this);
        this.state = {
            showTip: true
        };
    }

    componentDidMount() {
        // 获取当前元素的滚动父级
        this.scrollParent = uiHelper.getScrollParent(this.refs.dragContainer);
    }

    getContainer() {
        return {
            width: this.refs.dragContainer.offsetWidth
            ,height: this.refs.dragContainer.offsetHeight
        };
    }

    // 获取元素相对可视区的top值
    getClientTop(obj) {
        let top = 0;
        while(obj) {
            top += obj.offsetTop;
            obj = obj.offsetParent;
        }
        
        return top - this.scrollParent.scrollTop;
    }

    getAllCells() {
        const container = this.refs.dragContainer;
        return container.getElementsByClassName('drag-box');
    }

    /* 获取当前移到了哪个格子 可识别区域为当前格子内
    注：特殊：由于有些用户喜欢移动时向格子前方插入 所以每个格子的可识别区域向左扩大24px 如同时在多个格子的可识别区域中 取最后一个格子
    */
    getDesCellIndex(currentItem) {
        const containerTop = this.getClientTop(this.refs.dragContainer);
        const cells = this.getAllCells();
        let destIndex = null;
        for(let i = 0; i < cells.length; i++) {
            if(currentItem.index != i) {
                cells[i].style.borderColor = 'rgba(230, 231, 232, 0.5)';
            }
            if(currentItem.index !== i &&
                currentItem.pointX > (cells[i].offsetLeft - 24) &&
                (currentItem.pointY - containerTop) > cells[i].offsetTop &&
                (currentItem.pointX < cells[i].offsetLeft + cells[i].offsetWidth) &&
                ((currentItem.pointY - containerTop) < cells[i].offsetTop + cells[i].offsetHeight)
            ) {
                destIndex = i;
            }
        }
        return destIndex != null ? destIndex : currentItem.index;
    }

    // 被识别的格子边框将变为蓝色
    overCellStyle(currentItem) {
        const destIndex = this.getDesCellIndex(currentItem);
        if(destIndex == currentItem.index) return;
        const cells = this.getAllCells();
        cells[destIndex].style.borderColor = 'rgba(52,154,246,0.8)';

    }

    moveToCell(currentItem) {
        const destIndex = this.getDesCellIndex(currentItem);
        currentItem.cell.style.left = '';
        currentItem.cell.style.top = '';
        if(destIndex == currentItem.index) return;
        const datas = Object.assign([], this.props.datas);
        const currentCell = this.props.datas[currentItem.index];
        // 在数组中删除当前项 并在destIndex位置插入此项
        datas.splice(currentItem.index,1);
        datas.splice(destIndex,0,currentCell);
        // 将调整顺序后的数据通知给父级
        this.props.setChangeDatas(datas);
    }

    handleTouchAdd(e) {
        e.preventDefault();
        this.props.handleTouchAdd && this.props.handleTouchAdd();
    }

    closeTip(e) {
        if(this.state.showTip) {
           this.setState({ showTip: false });
        }
    }

    renderAdd() {
        return (<div className="drag-cell" onTouchTap={this.handleTouchAdd}>
                    <div className="border-1px drag-add">
                        <span />
                        <span className="y" />
                    </div>
                </div>);
    }

	render() {
        const hasData = this.props.datas && this.props.datas.length > 0;
		return (
			<div ref="dragContainer" className={classNames('ui-drag-box',this.props.cls)}>
                {this.renderAdd()}
			    {hasData && this.props.datas.map((item,index) => {
                    return  (<div className="drag-cell" key={`drag${index}`}>
                                <DragCell  data={item}
                                            index={index}
                                            showTip={index == 0 ? this.state.showTip : false}
                                            closeTip={this.closeTip}
                                            moveToCell={this.moveToCell}
                                            getContainer={this.getContainer}
                                            overCellStyle={this.overCellStyle}
                                            translation={this.props.translation} />
                            </div>);
				})}
			</div>);
	}
}
export default DragGrid;


// WEBPACK FOOTER //
// ./src/components/Field_Components/Staff/DragGrid/DragGrid.js